import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const FACTORIAL = () => {
  return (
    <CardSection id="FACTORIAL" title="FACTORIAL">
      <Paragraph>정수와 그 아래의 모든 정수의 곱을 반환합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>FACTORIAL(NUMBER)</Paragraph>
        <Ul>
          <Li>
            <b>NUMBER</b>는 실수입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>현재 지원 준비중인 함수입니다.</Paragraph>
        {/* <Img src="computeCeiling" /> */}
      </ListSection>
    </CardSection>
  );
};
